import { FC, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useFirebaseTableFilterState,
  useFirebaseTableFilterStore,
} from "../../Firebase/hooks/useFirebaseTableFilters";
import { FirebaseTableFilterTextView } from "../../Firebase/views/FirebaseTableFilterTextView";
import { useT } from "../../Translation/hooks/useT";
import { SEARCH_DEBOUNCE_MS } from "./ProjectDetailsPage";

interface Props {
  onSearchChange: (searchTerm: string | null) => void;
}

export const CallsSearchInputWithUrlSync: FC<Props> = ({ onSearchChange }) => {
  const t = useT();
  const [searchParams] = useSearchParams();
  const filterStore = useFirebaseTableFilterStore();
  const hasInitialized = useRef(false);

  // Watch for search filter changes
  const searchValue = useFirebaseTableFilterState(
    (state) => state.filters.agentNameOrCallId?.value as string | null,
  );

  // Initialize from URL on first load
  useEffect(() => {
    if (!hasInitialized.current) {
      const urlSearchTerm = searchParams.get("search");
      if (urlSearchTerm) {
        filterStore
          .getState()
          .setFilterValue("text", "agentNameOrCallId", urlSearchTerm);
      }
      hasInitialized.current = true;
    }
  }, [searchParams, filterStore]);

  // Update URL when search value changes
  useEffect(() => {
    if (hasInitialized.current) {
      onSearchChange(searchValue);
    }
  }, [searchValue, onSearchChange]);

  return (
    <FirebaseTableFilterTextView
      size="small"
      filterName="agentNameOrCallId"
      placeholder={t("FirebaseTableFilterView_Label_Search")}
      debounceMs={SEARCH_DEBOUNCE_MS}
      hasClearButton
      sx={{ backgroundColor: "background.paper" }}
    />
  );
};
